import { initStickable, Stickable } from "@misonou/react-css-utils";
import { createBreakpointContext } from "zeta-dom-react";
import dom from "zeta-dom/dom";
import config from "src/config";

export { useMediaQuery } from "zeta-dom-react";
export * from "@misonou/react-css-utils";
export const { useBreakpoint } = createBreakpointContext(config.breakpoints);

let stickable: Stickable;

export function stickToViewport(element: HTMLElement, dir: Zeta.Direction, within: () => Zeta.Rect) {
    stickable.add(element, dir, within);
}

dom.ready.then(() => {
    stickable = initStickable(document.getElementById('root')!);
});
